export const purchaseUrl = 'https://muebles-faciles-en-casa.impultienda.ar/checkout'

export const pricingAnchor = '#pricing'

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/jABAYWjEfXdjSp7CHMhmQ2/Kit_completo_de_muebles_faciles_en_casa.png'

export const prices = {
  today: '$19.990',
  tomos: '$19.990',
  bonusTotal: '$64.950',
  before: '$84.940',
  after: '$26.980',
  discount: '76%',
  savings: '$64.950',
}

export const heroStats = [
  ['5', 'Tomos completos'],
  ['5', 'Bonos incluidos'],
  ['50', 'Proyectos paso a paso'],
  ['400', 'Páginas de contenido'],
  ['PDF', 'Acceso digital inmediato'],
] as const

export const projectSteps = [
  'medidas',
  'lista de cortes',
  'piezas identificadas',
  'marcado',
  'armado',
  'lijado',
  'terminación',
  'revisión final',
]

export const painQuestions = [
  '¿Qué madera compro?',
  '¿Qué tamaño tiene que tener cada pieza?',
  '¿Cuánto tengo que cortar?',
  '¿Qué pieza va primero?',
  '¿Dónde van los tornillos?',
  '¿Cómo hago para que quede derecho?',
  '¿Tengo que calcular todo yo?',
  '¿Necesito muchas herramientas?',
  '¿Y si corto mal?',
  '¿Y si después las piezas no coinciden?',
  '¿Este proyecto será demasiado difícil?',
]

export const needToKnow = [
  'Qué construir',
  'Qué piezas necesitás',
  'Cuánto tienen que medir',
  'Y cómo armarlas',
]

export const pathSteps = [
  'Elegís un proyecto.',
  'Revisás las medidas.',
  'Preparás las piezas.',
  'Seguís el armado.',
]

export const usageSteps = [
  [
    '01',
    'Elegí qué necesitás',
    'Living · Cocina · Dormitorio · Entrada · Lavadero · Plantas · Mascotas · Escritorio y más.',
  ],
  ['02', 'Revisá las medidas', 'Cada proyecto te indica las dimensiones del mueble y de las piezas necesarias.'],
  [
    '03',
    'Prepará los cortes',
    'Tenés una lista clara para saber qué piezas necesitás y cuánto debe medir cada una.',
  ],
  ['04', 'Seguí el armado', 'Marcado, perforaciones, uniones, lijado, terminación y control final.'],
] as const

export const roomPath = ['Living', 'Cocina', 'Dormitorio', 'Entrada y lavadero', 'Plantas y decoración']

export const roomExtras = 'Mascotas · Escritorio · Espacios chicos · Mate y café · Herramientas'

export const beginnerTools = [
  'cortes rectos',
  'formas simples',
  'pocas piezas',
  'tornillos para madera',
  'cola',
  'taladro/atornillador',
  'lijado',
  'terminaciones sencillas',
]

export const beginnerSteps = [
  ['1', 'Elegí', 'Buscá el proyecto que querés hacer.'],
  ['2', 'Medí', 'Confirmá que funcione correctamente en el lugar elegido.'],
  ['3', 'Prepará', 'Conseguí las piezas utilizando la lista de cortes.'],
  ['4', 'Construí', 'Seguí el orden de armado indicado.'],
] as const

export const modules = [
  {
    icon: '🛋️',
    name: 'Tomo 1 — Muebles para el living',
    period: '5 proyectos para crear un living más práctico y organizado.',
    content: [
      ['Mesita auxiliar abierta', 'Una mesa compacta para colocar junto al sillón.'],
      ['Biblioteca baja de dos huecos', 'Para libros, decoración y objetos cotidianos.'],
      ['Módulo para vinilos', 'Un espacio para organizar discos en posición vertical.'],
      ['Caja para mantas', 'Guardado abierto para mantas y almohadones pequeños.'],
      ['Repisa para cuadros apoyados', 'Una solución sencilla para decorar una pared.'],
    ],
  },
  {
    icon: '🍽️',
    name: 'Tomo 2 — Cocina más ordenada',
    period: 'Aprovechá mejor mesadas y alacenas con proyectos simples.',
    content: [
      ['Especiero de sobremesa', 'Dos niveles para mantener los frascos organizados.'],
      ['Puente para tazas', 'Permite aprovechar mejor la altura de una alacena.'],
      ['Organizador para sobres de té', 'Dos compartimentos para infusiones y pequeños paquetes.'],
      ['Bandeja para condimentos', 'Un espacio para agrupar aceite, sal, especias y envases.'],
      ['Caja para tablas de cocina', 'Guardado vertical para mantenerlas organizadas.'],
    ],
  },
  {
    icon: '🛏️',
    name: 'Tomo 3 — Dormitorio práctico',
    period: 'Sumá guardado y organización sin complicar el espacio.',
    content: [
      ['Mesita de luz con estante', 'Dos niveles para organizar objetos junto a la cama.'],
      ['Cubo para bolsos', 'Un módulo compacto para bolso o mochila.'],
      ['Caja para accesorios', 'Ideal para cinturones, pañuelos y objetos pequeños.'],
      ['Repisa para libros de noche', 'Una superficie compacta para pared.'],
      ['Organizador de cosméticos', 'Para reunir frascos y productos pequeños.'],
    ],
  },
  {
    icon: '🚪',
    name: 'Tomo 4 — Entrada y lavadero',
    period: 'Dos sectores de la casa donde el orden puede hacer una gran diferencia.',
    content: [
      ['Zapatero bajo de dos niveles', 'Para organizar el calzado de uso diario.'],
      ['Perchero para llaves y correas', 'Un punto fijo para los accesorios que utilizás al salir.'],
      ['Bandeja vaciabolsillos', 'Para llaves, monedas, tarjetas y objetos pequeños.'],
      ['Organizador para paños secos', 'Dos niveles para textiles y repuestos.'],
      ['Caja para accesorios de limpieza', 'Dos compartimentos para organizar accesorios secos.'],
    ],
  },
  {
    icon: '🌿',
    name: 'Tomo 5 — Plantas y decoración',
    period: 'Madera, plantas y proyectos para transformar pequeños rincones.',
    note: 'Cinco proyectos para sumar madera y plantas a distintos sectores de tu casa.',
    content: [
      ['Base baja para una maceta', ''],
      ['Cubremaceta cuadrado', ''],
      ['Bandeja para tres suculentas', ''],
      ['Exhibidor de objetos y plantas', ''],
      ['Repisa para mini macetas', ''],
    ],
  },
]

export const projectMeasures = [
  ['Ancho', '450 mm'],
  ['Profundidad', '280 mm'],
  ['Altura', '178 mm'],
] as const

export const cutList = [
  ['A', 'Base', '450 × 280 × 18 mm', '1'],
  ['B', 'Frente', '450 × 160 × 18 mm', '1'],
  ['C', 'Trasera', '450 × 160 × 18 mm', '1'],
  ['D', 'Lateral', '244 × 160 × 18 mm', '1'],
  ['E', 'Lateral', '244 × 160 × 18 mm', '1'],
] as const

export const markingTips = [
  'identificar cada pieza',
  'presentarlas antes de fijar',
  'revisar medidas',
  'marcar puntos de unión',
  'realizar perforaciones guía',
  'comprobar la escuadra',
]

export const assemblySteps = [
  'Presentá las piezas.',
  'Sujetalas correctamente.',
  'Prepará las perforaciones.',
  'Aplicá la cola.',
  'Realizá las primeras uniones.',
  'Completá la estructura.',
  'Revisá el armado.',
]

export const finishingTips = [
  'lija 120',
  'lija 180',
  'suavizado de cantos',
  'eliminación del polvo',
  'pintura',
  'acabado natural',
  'combinaciones de madera y color',
]

export const finalChecks = [
  'Estabilidad',
  'Escuadra',
  'Tornillos',
  'Cantos',
  'Astillas',
  'Terminación',
  'Ubicación',
]

export const bonuses = [
  {
    number: '01',
    icon: '🐾',
    name: 'Un rincón para tu mascota',
    value: '$10.990',
    description: '5 proyectos para crearle un espacio más cómodo y organizado.',
    items: [
      'Cama abierta para almohadón',
      'Caja para juguetes',
      'Bandeja para platos removibles',
      'Colgador de paseo',
      'Módulo para accesorios de mascota',
    ],
  },
  {
    number: '02',
    icon: '💻',
    name: 'Escritorio despejado',
    value: '$11.990',
    description: '5 proyectos para mejorar tu espacio de trabajo o estudio.',
    items: [
      'Elevador para objetos de escritorio',
      'Bandeja para hojas A4',
      'Organizador de útiles en dos canales',
      'Estantería de sobremesa',
      'Pareja de sujetalibros',
    ],
  },
  {
    number: '03',
    icon: '🏠',
    name: 'Orden en espacios chicos',
    value: '$12.990',
    description: '5 soluciones compactas para aprovechar mejor cada rincón.',
    featured: true,
    items: [
      'Caja para controles remotos',
      'Organizador para toallas enrolladas',
      'Caja para rollos de repuesto',
      'Divisor de estante para ropa',
      'Bandeja para cargadores guardados',
    ],
  },
  {
    number: '04',
    icon: '🧉',
    name: 'Mate, café y regalos',
    value: '$13.990',
    description: '5 proyectos útiles para organizar, disfrutar y crear detalles.',
    items: [
      'Estación de mate de sobremesa',
      'Organizador de café',
      'Bandeja para presentar regalos',
      'Caja para sobres y recetas',
      'Mini exhibidor para recuerdos',
    ],
  },
  {
    number: '05',
    icon: '🧰',
    name: 'Tu rincón de herramientas',
    value: '$14.990',
    description: '5 proyectos para organizar mejor tu espacio de trabajo.',
    items: [
      'Caja para herramientas manuales',
      'Clasificador para herrajes en envases',
      'Estante de apoyo para consumibles',
      'Colgador para accesorios livianos',
      'Bandeja para piezas en proceso',
    ],
  },
]

export const includedTomos = [
  'Tomo 1 — Muebles para el living',
  'Tomo 2 — Cocina más ordenada',
  'Tomo 3 — Dormitorio práctico',
  'Tomo 4 — Entrada y lavadero',
  'Tomo 5 — Plantas y decoración',
]

export const includedExtras = [
  '50 proyectos completos',
  '400 páginas de contenido',
  'Medidas de cada proyecto',
  'Listas de cortes',
  'Piezas identificadas',
  'Armado paso a paso',
  'Lijado y terminación',
  'Revisión final',
  'Formato PDF',
]

export const testimonials = [
  {
    name: 'Laura Giménez',
    age: 42,
    city: 'Córdoba',
    headline: '“Nunca había agarrado un taladro y hoy tengo mi mesita en el living.”',
    text: 'Llevé la lista de cortes a la maderera, me dieron todo cortado y el sábado ya la estaba lijando. Cada pieza tiene una letra: sabía exactamente qué iba con qué.',
    project: 'Mesita auxiliar abierta',
  },
  {
    name: 'Martín Ferreyra',
    age: 51,
    city: 'Rosario',
    headline: '“Tenía las herramientas guardadas hace años. Me faltaba un plan.”',
    text: 'Con el zapatero bajo aprendí a marcar las perforaciones y comprobar la escuadra. Después hice la caja del Bono 5 y el garage está ordenado por primera vez.',
    project: 'Zapatero bajo de dos niveles',
  },
  {
    name: 'Carolina Ruiz',
    age: 34,
    city: 'CABA',
    headline: '“Vivo en un monoambiente y cada centímetro cuenta.”',
    text: 'Pedí las piezas cortadas y armé en el piso del living. El especiero y el puente para tazas me liberaron media mesada.',
    project: 'Especiero de sobremesa',
  },
  {
    name: 'Ricardo Paz',
    age: 62,
    city: 'Mendoza',
    headline: '“Un proyecto para hacer con mi nieto los fines de semana.”',
    text: 'Arrancamos con la base para maceta y terminamos haciendo el exhibidor de plantas del patio. Las medidas están todas, no tuve que calcular nada.',
    project: 'Exhibidor de objetos y plantas',
  },
  {
    name: 'Valeria Sosa',
    age: 46,
    city: 'Mar del Plata',
    headline: '“La entrada de casa era un caos de zapatillas y llaves.”',
    text: 'Hice el perchero y la bandeja vaciabolsillos en un fin de semana. Lo que hubiera gastado comprándolos hechos me alcanzó para tres proyectos más.',
    project: 'Perchero para llaves y correas',
  },
]

export const buyers = [
  ['Sofía', 'Salta'],
  ['Gustavo', 'Neuquén'],
  ['Mariana', 'La Plata'],
  ['Diego', 'Tucumán'],
  ['Florencia', 'Bahía Blanca'],
  ['Hernán', 'Santa Fe'],
  ['Natalia', 'Posadas'],
  ['Pablo', 'Bariloche'],
  ['Silvina', 'Corrientes'],
] as const

export const faqs = [
  [
    '¿Sirve si nunca hice carpintería?',
    'Sí. Los proyectos están organizados para que puedas identificar las piezas, revisar las medidas y seguir el armado en orden. Muchos utilizan cortes rectos y formas simples.',
  ],
  [
    '¿Necesito saber diseñar muebles?',
    'No. Las medidas y piezas necesarias ya están definidas dentro de cada proyecto.',
  ],
  [
    '¿Tengo que cortar toda la madera yo?',
    'No necesariamente. Podés llevar la lista de cortes a una maderera y pedir las piezas ya cortadas.',
  ],
  [
    '¿Qué herramientas necesito?',
    'Depende del proyecto, pero principalmente se trabaja con cinta métrica, escuadra, lápiz, prensas, taladro/atornillador, mechas, tornillos, cola y lijas.',
  ],
  [
    '¿Qué madera utilizan los proyectos?',
    'Los planos están planteados principalmente con multilaminado de 18 mm y, cuando corresponde, fondos de 6 mm. Podés adaptarlos a otro material, pero si cambia el espesor también pueden cambiar algunas medidas y uniones.',
  ],
  [
    '¿Necesito un taller profesional?',
    'No. La propuesta está orientada a proyectos domésticos que puedan realizarse utilizando herramientas básicas o piezas previamente cortadas.',
  ],
  [
    '¿Cuántos proyectos recibo?',
    '50 proyectos en 10 ebooks digitales (aprox. 400 páginas): 25 proyectos en los cinco tomos principales + 25 proyectos dentro de los cinco bonos.',
  ],
  [
    '¿Los bonos tienen costo?',
    'Hoy no. Su valor percibido combinado es de $64.950 ARS, pero con la oferta actual los 5 bonos están incluidos gratis.',
  ],
  [
    '¿Cómo recibo el producto?',
    'Es un producto digital. Recibís el material en formato PDF para consultarlo desde el celular, la computadora o la tablet, y lo conservás de por vida.',
  ],
  [
    '¿Cómo funciona la garantía?',
    'Tenés 7 días para revisar el producto. Si necesitás solicitar una devolución dentro del período correspondiente, escribís a compradigitalyaa@gmail.com.',
  ],
] as const
